import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from '../basic';
// import RptTable from '../rpttable';
import TotalContainer from './TotalContainer';
import DimensionNavTree from './DimensionNavTree'
import EChartDisplay from '../echart/echart/eChartDisplay';
import * as  eChartDemoData from '../echart/eChartDemoData';
import { genAction, proxy } from '../../helpers/util';
import * as  eChartCommon from '../echart/eChartCommon';
import * as groupConditionRedux from '../../redux/groupCondition';
import { Input, Modal, Button } from 'antd';
let RptTable = null;
class RptTableContainer extends Component {
  constructor(props) {
    super(props);
    RptTable = cb.isInTouchReport(props.viewModel) ? require('../grid-touch').default : require('../rpttable').default;
    let viewid = _.get(props.viewModel.getParams(), 'query.viewid');
    if (!viewid)
      viewid = "";
    this.state = {
      displayType: 1,// 1 单表 2 单图 3 多图+表
      layOutConfig: {},
      eChartConfig: {},
      billnum: "",
      groupSchemaId: "",
      groupSchemaName: "",
      condition: {},
      firstQueryDone: false,
      // publishMenu: false,
      viewid: viewid,
      isPc: true,
      isMobile: false,
      dimensionId: 0,
      height: props.height || document.body.clientHeight,
      listHeaderHeight: 0,
      totalHeight: 0
    };
    this.setDisplayNavTree(this.state.dimensionId);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // RptTableContainer shouldComponentUpdate
    const { groupConditionState, groupConditionRedux } = this.props;
    let id = _.get(nextProps.groupConditionState[this.state.billnum], "refreshGroupSchemaId");
    if (id && id == this.state.groupSchemaId) {
      this.getConfig();
      groupConditionRedux.setValue(this.state.billnum, { refreshGroupSchemaId: "" });
      return true;
    }
    return true;
  }
  componentDidMount() {
    let self = this;
    //注册分组方案切换事件
    this.props.viewModel.on('refreshEChartConfig', (params) => {
      // if (eChartDemoData.demoConfig.isDemoConfig == true && params.groupSchemaId == eChartDemoData.demoConfig.demoGroupSchemaId) {
      //   this.getConfigDemo(params);
      // }
      // else {
      this.getConfig(params);
      // }
    });
    //注册点击过滤事件
    this.props.viewModel.on("filterClick", (params) => {
      let condition = cb.utils.extend(true, {}, params.condition);
      if (condition.commonVOs) {
        condition.commonVOs.forEach(item => {
          if(item.itemName == 'vouchdate') {
            const filterVM = this.props.viewModel.getCache('FilterViewModel');
            const predicateValue = filterVM.get('vouchdate').getFromModel().getCache('predicateValue');
            if(predicateValue) {
              item.value1 = predicateValue;
              item.value2 = predicateValue;
            }
          }
        });
      }
      this.setState({ condition });
    });

    this.props.viewModel.on('firstQueryDone', (params) => {
      this.state.firstQueryDone = params;
    });

    this.props.viewModel.on('getPublishMenuInfo', () => {
      let viewModel = self.props.viewModel;
      let params = {};
      params.name = viewModel.getParams().name;
      params.groupSchemaName = self.state.groupSchemaName;
      params.billnum = viewModel.getParams().billNo;// self.state.billnum;
      params.isPc = self.state.isPc;
      params.isMobile = self.state.isMobile;
      if (!!self.state.groupSchemaId)
        params.groupSchemaId = self.state.groupSchemaId;
      params.condition = self.state.condition;
      viewModel.execute('setPublishMenuInfo', params);
    });


    this.props.viewModel.on('dimensionChanged', (params) => {
      this.setDisplayNavTree(params.dimensionId);
      this.setState({ dimensionId: params.dimensionId });
    });

    // this.props.viewModel.on('publishMenu', (params) => {
    //   this.setState({ publishMenu: true });
    // });
    this.props.viewModel.on('listHeaderHeightUpdate', (height, filterName) => {
      let h = (this.props.height || document.body.clientHeight) - height - 20 - this.state.totalHeight;
      this.setState({ height: h, listHeaderHeight: height + 20 });
    });
    this.props.viewModel.on('totalHeightUpdate', height => {
      let h = (this.props.height || document.body.clientHeight) - height - 2 - this.state.listHeaderHeight;
      this.setState({ height: h, totalHeight: height + 2 });
    });
  }
  setDisplayNavTree(dimensionId) {
    if (dimensionId) {
      this.props.viewModel.setCache('bDisplayNavTree', true);
    }
    else {
      this.props.viewModel.setCache('bDisplayNavTree', false);
    }

  }
  // getPublishMenuCard(viewModel) {

  //   let self = this;
  //   let content;
  //   if (self.state.publishMenu == true) {
  //     let name = viewModel.getParams().name;
  //     let groupSchemaName = self.state.groupSchemaName;

  //     let card;
  //     card = <div className="publishMenu_count">
  //       <span>方案名称:</span>
  //       <Input
  //         id="publishMenu_Title"
  //         placeholder="请输入"
  //         defaultValue={name + "_" + groupSchemaName}
  //       />
  //     </div>;

  //     content =
  //       <Modal
  //         className="publishMenu"
  //         title={"发布菜单"}
  //         onOk={(e) => this.handleOk(e)}
  //         onCancel={(e) => this.handleCancel(e)}
  //         visible={true}
  //       >
  //         {card}
  //       </Modal>;
  //   }
  //   return content;
  // }

  // handleOk = (e) => {
  //   let ele = document.getElementById('publishMenu_Title')
  //   let name = ele.value;
  //   if (name == "" || name.length > 16) {
  //     cb.utils.alert("名称不可为空且长度小于16个字。");
  //     return;
  //   }
  //   let billnum = this.state.billnum;
  //   let groupSchemaId = this.state.groupSchemaId;
  //   let condition = JSON.stringify(this.state.condition);
  //   let params = { billnum, name, groupSchemaId, condition };

  //   let callback = (json) => {
  //     if (json.code === 200) {
  //       cb.utils.alert("报表方案已发布。");
  //       this.setState({ publishMenu: false });
  //     }
  //     else {
  //       cb.utils.alert(json.message);
  //     }
  //   }
  //   this.actionsProxy('/report/publishMenu', 'POST', params, callback);
  // }
  // handleCancel = (e) => {
  //   this.setState({ publishMenu: false });
  // }

  componentWillUnmount() {
    // //重写组件的setState方法，直接返回空
    // this.setState = (state, callback) => {
    //   return;
    // };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.height != nextProps.height) {
      this.setState({ height: nextProps.height - this.state.listHeaderHeight - this.state.totalHeight });
    }
  }
  actionsProxy(url, method, params, callback) {
    const config = { url: url, method: method, params: params };
    proxy(config)
      .then(json => {
        callback(json);
      });
  }

  // getConfig(params) {
  //   let billnum = params ? params.billnum : this.state.billnum;
  //   let groupSchemaId = params ? params.groupSchemaId : this.state.groupSchemaId;
  //   let groupSchemaName = params ? params.groupSchemaName : this.state.groupSchemaName;
  //   let param = { billnum: billnum, groupSchemaId: groupSchemaId };
  //   let callback = (json) => {
  //     if (json.code === 200) {
  //       if (json.data) {
  //         let isCrossTable = json.data.isCrossTable;
  //         if (isCrossTable == false) {
  //           if (json.data.displayStyle) {
  //             let displayType = json.data.displayStyle;
  //             let layOutConfig = json.data.pageLayout ? JSON.parse(json.data.pageLayout) : {};
  //             let eChartConfig = json.data.chartConfig ? JSON.parse(json.data.chartConfig) : {};
  //             let isPc = json.data.hasOwnProperty("isPc") ? json.data.isPc : true;
  //             let isMobile = json.data.hasOwnProperty("isMobile") ? json.data.isMobile : false;
  //             let obj = { displayType, layOutConfig, eChartConfig, isMobile, isPc, billnum, groupSchemaId, groupSchemaName };
  //             this.setState(obj);
  //             return;
  //           }
  //         }
  //       }
  //     }
  //     eChartCommon.LogChartInfo("图形报表_配置信息读取失败或者交叉表不支持 param = " + JSON.stringify(param) + " json.message = " + json.message, "", 999);
  //     this.setState({ displayType: 1, layOutConfig: {}, eChartConfig: {}, isMobile: true, isPc: true, billnum, groupSchemaId, groupSchemaName });
  //   }
  //   this.actionsProxy('/report/getGroupSetting', 'GET', param, callback);
  // }

  getConfig(params) {
    let billnum = params ? params.billnum : this.state.billnum;
    let groupSchemaId = params ? params.groupSchemaId : this.state.groupSchemaId;
    let groupSchemaName = params ? params.groupSchemaName : this.state.groupSchemaName;
    let param = { billnum: billnum, groupSchemaId: groupSchemaId };
    let callback = (json) => {

      if (json.code === 200 && json.data && json.data.isCrossTable == false && json.data.displayStyle) {
        let displayType = json.data.displayStyle;
        let layOutConfig = json.data.pageLayout ? JSON.parse(json.data.pageLayout) : {};
        let eChartConfig = json.data.chartConfig ? JSON.parse(json.data.chartConfig) : {};
        let isPc = json.data.hasOwnProperty("isPc") ? json.data.isPc : true;
        let isMobile = json.data.hasOwnProperty("isMobile") ? json.data.isMobile : false;
        let obj = { displayType, layOutConfig, eChartConfig, isMobile, isPc, billnum, groupSchemaId, groupSchemaName };
        this.setState(obj);
      }
      else {
        eChartCommon.LogChartInfo("图形报表_配置信息读取失败或者交叉表不支持图形显示 param = " + JSON.stringify(param) + " json.data.isCrossTable = " + _.get(json, "data.isCrossTable") + " json.message = " + json.message, "", 999);
        let isPc = json.data && json.data.hasOwnProperty("isPc") ? json.data.isPc : true;
        let isMobile = json.data && json.data.hasOwnProperty("isMobile") ? json.data.isMobile : false;
        this.setState({ displayType: 1, layOutConfig: {}, eChartConfig: {}, isMobile, isPc: true, billnum, groupSchemaId, groupSchemaName });
      }
    }
    this.actionsProxy('/report/getGroupSetting', 'GET', param, callback);
  }

  render() {
    const { meta, viewModel } = this.props;
    let otherCom = null;
    if (this.state.displayType == 1)//单表
    {
      otherCom = this.renderTable();
    }
    else if (this.state.displayType == 2)//单图
    {
      otherCom = this.renderChart();
    }
    else if (this.state.displayType == 3)//表和多图。也可能只有多图
    {
      otherCom = this.renderTableAndChart();
    }
    // let publishMenu = this.getPublishMenuCard(viewModel);

    let bDisplay = this.props.viewModel.getCache('bDisplayNavTree');
    let clsName = bDisplay ? "RptTableContainer_Row1" : "";
    if (cb.isInTouchReport(this.props.viewModel)) {
      clsName = clsName + " RptTableContainer_Row1_TouchRptCls";
    }
    return (
      <Row className={clsName}   >
        <TotalContainer
          meta={meta}
          billnum={this.state.billnum}
          viewModel={viewModel}
          // firstQueryDone={this.state.firstQueryDone}
          viewid={this.state.viewid}
        />
        {/* {otherCom} */}
        <Row className={bDisplay ? "RptTableContainer_Row2" : ""}   >
          <Col style={{ display: (bDisplay ? "" : "none") }} className={bDisplay ? "RptTableContainer_Col21" : ""} >
            <DimensionNavTree
              billnum={this.state.billnum}
              viewModel={viewModel}
            />
          </Col>
          <Col className={bDisplay ? "RptTableContainer_Col22" : ""} >
            {otherCom}
          </Col>
        </Row>
        {/* {publishMenu} */}
      </Row>
    );
  }

  renderTable() {
    const { meta, width, viewModel } = this.props;
    const style = meta.cStyle ? JSON.parse(meta.cStyle) : {};
    let tableWidth = style.width || width;
    let bDisplay = this.props.viewModel.getCache('bDisplayNavTree');
    if (bDisplay)
      tableWidth = tableWidth - 241 - 20;// 20  padding-left
    const columns = {};
    if (meta.controls) {
      meta.controls.forEach(column => {
        columns[column.cItemName] = column;
      })
    }
    const controlModel = viewModel.get(meta.childrenField || meta.cCode);
    return (
      <RptTable
        width={tableWidth}
        height={this.state.height}
        listHeaderHeight={this.state.listHeaderHeight}
        code={meta.cGroupCode}
        columns={columns}
        style={style}
        model={controlModel} tableClass="rptTable" tableTyep={'rptTable'} />
    );
  }

  renderChart() {
    let charts = this.getSubChartContent(this.state.eChartConfig);
    return (<div>{charts}</div>);
  }

  renderTableAndChart() {
    let self = this;
    const { meta, width, viewModel } = this.props;
    const style = meta.cStyle ? JSON.parse(meta.cStyle) : {};
    const tableWidth = style.width || width;
    const columns = {};
    if (meta.controls) {
      meta.controls.forEach(column => {
        columns[column.cItemName] = column;
      })
    }
    const controlModel = viewModel.get(meta.childrenField || meta.cCode);
    let rpt = <RptTable width={tableWidth} code={meta.cGroupCode} columns={columns}
      style={style} model={controlModel} tableClass="rptTable" tableTyep={'rptTable'} />;
    let content = [];
    content = self.getRows(this.state.layOutConfig.rows, content, rpt, controlModel);
    return (
      <div>{content}</div>
    );
  }

  getRows(config, content, rpt, controlModel) {
    let self = this;
    config.forEach(rowEle => {
      let curRow = [];
      rowEle.forEach(colEle => {
        if (colEle.widgetType == "rpt") {
          curRow.push(<Col span={colEle.colspan}> {rpt}</Col>);
        }
        else if (colEle.widgetType == "chart") {
          let charts = self.getSubChartContent(self.state.eChartConfig);
          curRow.push(<Col span={colEle.colspan}> {charts}</Col>);
        }
        else if (colEle.widgetType == "rows") {
          let innerContent = [];
          innerContent = self.getRows(colEle.widgetValue, innerContent, rpt, controlModel);
          curRow.push(<Col span={colEle.colspan}> {innerContent}</Col>);
        }
      });
      content.push(<Row colCount={12}>{curRow}</Row>);
    });
    return content;
  }


  getSubChartContent(eChartConfig) {

    let self = this;
    let queryParams = {
      billnum: self.state.billnum,
      groupSchemaId: self.state.groupSchemaId,
      condition: self.state.condition
    };
    return <EChartDisplay
      chartDisplayType={"rpt"}
      eChartConfig={eChartConfig}
      viewModel={self.props.viewModel}
      queryParams={queryParams}
      firstQueryDone={this.state.firstQueryDone}
      viewid={this.state.viewid}
    />;

  }


}

function mapStateToProps(state) {
  return {
    groupConditionState: state.groupCondition
  }
}

function mapDispatchToProps(dispatch) {
  return {
    groupConditionRedux: bindActionCreators(groupConditionRedux, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RptTableContainer);



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/RptTableContainer.jsx